<template>
  <div>
    <Card :bordered="false">
      <p slot="title">优惠、免费政策</p>
      <div v-html="data"></div>
    </Card>
  </div>
</template>

<script>
// import Policy from '../../../mock/Policy.json'
import { httpAction } from '@/api/manage'
import api from '@/api'
export default {
  data () {
    return {
      // Policy,
      data: []
    }
  },
  mounted () {
    this.getPolicy()
  },
  methods: {
    getPolicy () {
       httpAction(api.noticeList, 'post',{type:3}).then(res => {
        this.data = res.data.noticeListVO[0].content
      })
    }
  }
}
</script>

<style>

</style>
